webpackJsonp([224622320330230],{

/***/ 1679:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"CardconnectCardInfo","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"issuer","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"subtype","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-cardconnect-card-info-858e2b16b0fe32bbec62.js